import { useCharactersStore } from '@/features/shared/stores/characters.store'
import { useWorkspace } from '@/features/workspace/stores/workspace.store'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useSpEditorStore } from '../stores/sp-editor.store'

export const useScreenplayEditor = () => {
    const { projectId: routeProjectId } = useParams<{ projectId: string }>()
    const { project } = useWorkspace()
    const projectId = routeProjectId || project?.id

    const setFeaturesEnabled = useSpEditorStore(state => state.setFeaturesEnabled)
    const addCharacter = useCharactersStore(state => state.addCharacter)

    useEffect(() => {
        const features = localStorage.getItem('spFeaturesEnabled')
        if (features) {
            setFeaturesEnabled(JSON.parse(features))
        }
    }, [setFeaturesEnabled])

    // Convenience wrapper for legacy/internal uses if any
    const addCharacterToDb = async (character: any) => {
        const fullCharacter = {
            id: crypto.randomUUID(),
            ...character,
            projectId: projectId,
        }
        addCharacter(fullCharacter)
    }

    return {
        addCharacterToDb
    }
}
